import React, { useState, useEffect } from 'react'
import { CardBody, Card, Col, Row } from 'reactstrap'
import Help from '../Help/Help'
import ICSButton from '../ICS/Button/ICSButton'
import BackButton from './BackButton/BackButton'

import './HeaderBar.css'

type HeaderRoute = {
  url?: string
  title: string
}
const areEqual = (prevProps, nextProps) => {
    return prevProps.routes.title === nextProps.routes.title;
};
const HeaderBar = React.memo(({origin,routes,help,children}: {
  origin?: string
  routes: HeaderRoute[]
  help?: { title: string; text: string | React.ReactFragment }
  children?: React.ReactNode
}) => {
  const [hidden, setHidden] = useState<boolean>(false)
  const [renderSmallLayout, setRenderSmallLayout] = useState<boolean>(
    window.innerWidth < 768 ? true : false
  )
  // const { help } = props

  const breadcrumbs = (routes: HeaderRoute[]) => {
    return (
      <>
        <ul
          className={
            !renderSmallLayout ? 'breadcrumbs-large' : 'breadcrumbs-small'
          }
        >
          <li className='headerElement'>{origin} &nbsp;/&nbsp;</li>
          {routes.map((route: HeaderRoute, index) => (
            <li className='headerElement' key={index}>
              <a id={route.title} href={route.url ? route.url : undefined}>
                {route.title}
              </a>

              {index !== routes.length - 1 ? <>&nbsp;/&nbsp;</> : ''}
            </li>
          ))}
        </ul>
      </>
    )
  }

  const hide = () => {
    setHidden(hidden ? false : true)
  }

  const checkSize = () => {
    if (window.innerWidth < 768 && !renderSmallLayout) {
      setRenderSmallLayout(true)
    }
    if (window.innerWidth > 768 && renderSmallLayout) {
      setRenderSmallLayout(false)
    }
  }

  useEffect(() => {
    window.addEventListener('resize', checkSize)
    return () => window.removeEventListener('resize', checkSize)
  })

  return (
    <>
      <Card className='header-bar'>
        <CardBody>
          <Row className='wivi-row'>
            <Col className='wivi-col' xs={{ size: 8 }}>
              {!renderSmallLayout ? <BackButton /> : null}
              {breadcrumbs(routes)}
            </Col>
            <Col>&nbsp;</Col>
            <Col xs={{ size: 2 }} className='text-right wivi-col'>
              <ICSButton
                height='100%'
                icon='help'
                id='helpBtn'
                type='default'
                stylingMode='contained'
                onClick={hide}
              />
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Help
        title={help?.title ? help.title : 'Help'}
        visible={hidden}
        onHiding={hide}
      >
        {help?.text ? help.text : 'No content'}
      </Help>
    </>
  )
},areEqual)

export default HeaderBar
